import type { SortOrderType } from 'models';

export const mapSortOrderNode = (sort?: SortOrderType) =>
  sort
    ? (
        {
          ascend: 1,
          descend: -1,
        } as const
      )[sort]
    : undefined;
